<template>
  <section class="c-section c-section--recovery-password py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8 col-lg-7">
          <div class="bg-white br--medium p-4 py-5">
            <h1 class="mb-2 text-center darks fs-21 w-bold">
              Reestablecer contraseña
            </h1>
            <p class="mb-4 text-center">
              Hola, ingresa tu nueva contraseña.
            </p>

            <div
              v-if="alert"
              class="c-card-alert p-3 mb-4 text-center"
              :class="`c-card-alert--${alert.type}`"
            >
              {{alert.message}}
            </div>

            <form
              class="c-form c-form--ghost"
              @submit.prevent="resetPassword()"
            >
              <div class="row gy-4 mb-4">
                <div
                  class="c-form-group col-12 col-lg-12"
                  :class="{'c-form-group--error': $v.newPassword.$error}"
                >
                  <input
                    type="password"
                    class="c-form__input w-100"
                    placeholder="Ingresar tu nueva contraseña"
                    v-model.trim="$v.newPassword.$model"
                  />

                  <span
                    class="c-form__error"
                    v-if="!$v.newPassword.required"
                  >
                    La contraseña esta vacía
                  </span>
                  <span
                    class="c-form__error"
                    v-if="!$v.newPassword.minLength"
                  >
                    La contraseña debe tener minimo
                    {{$v.newPassword.$params.minLength.min}}
                    carácteres.
                  </span>
                </div>

                <div
                  class="c-form-group col-12 col-lg-12"
                  :class="{'c-form-group--error': $v.confirmedNewPassword.$error}"
                >
                  <input
                    type="password"
                    class="c-form__input w-100"
                    placeholder="Confirma tu nueva contraseña"
                    v-model.trim="$v.confirmedNewPassword.$model"
                  />

                  <span
                    class="c-form__error"
                    v-if="!$v.confirmedNewPassword.isTheSame"
                  >
                    La contraseñas no son las mismas.
                  </span>
                </div>
              </div>

              <button
                type="submit"
                class="c-button c-button--primary w-100"
                :class="{'loading': isLoading}"
                :disabled="isLoading"
              >
                Actualizar contraseña
                <img class="c-button__spinner" src="@/assets/images/animations/spinner-white.png">
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  required,
  minLength,
} from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      arcux: {
        ...window.arcux,
      },

      newPassword: '',
      confirmedNewPassword: '',

      isLoading: false,

      alert: null,
    };
  },
  validations: {
    newPassword: {
      required,
      minLength: minLength(5),
    },
    confirmedNewPassword: {
      isTheSame: function isTheSame() {
        return this.newPassword === this.confirmedNewPassword;
      },
    },
  },
  methods: {
    resetPassword() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isLoading = true;

        const url = `${window.arcux.api}/users/profile/password`;

        fetch(url, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            uniqueid_resetpassword: this.$route.params.recovery_session,
            new_password: this.newPassword,
          }),
        })
          .then((res) => {
            if (res.status === 200 || res.status < 300) {
              return res.json();
            }

            return res.text().then((text) => { throw new Error(text); });
          })
          .then((data) => {
            if (!data.status) {
              throw data;
            }

            this.alert = {
              type: 'success',
              message: data.message,
            };

            setTimeout(() => {
              this.$router.push('/ingresar');
            }, 3000);
          })
          .catch(this.handleError);
      }
    },

    handleError(error) {
      let errorMessage = '';

      try {
        errorMessage = JSON.parse(error.message)?.message;
      } catch (err) {
        errorMessage = error.message;
      }

      this.alert = {
        type: 'error',
        message: errorMessage,
      };

      this.isLoading = false;

      setTimeout(() => {
        this.alert = null;
      }, 5000);
    },
  },
};
</script>
